'use strict';

var n=class t{static instance;queue=[];listener=null;constructor(){}static getInstance(){return t.instance||(t.instance=new t),t.instance}addToQueue(e,i=!0){i&&(this.queue.push(e),this.notifyListener(),e.finally(()=>{this.removeFromQueue(e);}));}removeFromQueue(e){this.queue=this.queue.filter(i=>i!==e),this.notifyListener();}setQueueChangeListener(e){this.listener=e;}notifyListener(){this.listener?this.listener(this.queue.length>0):console.log("Listener is not set");}},s=n.getInstance();

exports.a = n;
exports.b = s;
